// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
export default function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}


//////////////////
// WEBPACK FOOTER
// ./~/react-ga/dist/esm/utils/trim.js
// module id = 783
// module chunks = 2